import {ToastOptions} from "@ionic/core/dist/types/components/toast/toast-interface";

export const type = 'toast';

export interface ToastState extends ToastOptions {
    isOpen: boolean,
    color?: string,
    duration?: number,
    // Monotonic show counter. Each show bumps it so the toast overlay remounts
    // (fresh dismiss timer) and a stale dismiss from a replaced toast can be
    // recognised and ignored.
    generation: number,
}

export const initialState: ToastState = {
    isOpen: false,
    color: 'primary',
    duration: 5000,
    generation: 0,
};
